(function(){
    const type = document.querySelector('#type');
    const typeButtons = type.querySelectorAll('button');
    const changeFiltersEP = type.dataset.rest + 'change_filters';
    const changeSelectsEP = type.dataset.rest + 'change_selects';
    const filterProjectsEP = type.dataset.rest + 'filter_projects';
    const filter = document.querySelector('#filter');
    const projects = document.querySelector('#filtered');

    let currentType;
    function addFilterListeners(){
        const filterForm = filter.querySelector('form');
        if(filterForm){
            filterForm.addEventListener('change',updateSelects); 
            filterForm.addEventListener('submit',filterByCat);
            filterForm.addEventListener('reset',filterByCat);
        }
    }
    addFilterListeners();
    type.addEventListener('click',filterByType);


    function filterByType(e){
        let target;
        if(typeof e != 'string'){
            target = e.target;
            if(target.tagName != 'BUTTON') return;
            if(target == currentType) return;
        }
        else{
            target = document.querySelector('#type button');
        }
        typeButtons.forEach(button=>button.classList.remove('active'));
        target.classList.add('active');
        currentType = target;
        const targetType = target.dataset.type;
        document.body.classList.add('loading');
        const searchParams = `?project_type=${targetType}`;
        const url = new URL(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}${searchParams}`);
		window.history.pushState({}, '', url);
        console.log(`${changeFiltersEP}?project_type=${targetType}`);
        fetch(`${changeFiltersEP}?project_type=${targetType}`)
            .then(response=>response.json())
            .then(data => {
                data = JSON.parse(data); 
                filter.innerHTML = data.filter;
                projects.innerHTML = data.projects; 
                addFilterListeners();
                document.body.classList.remove('loading');
            })
            .catch(error=>{
                console.log(error);
                document.body.classList.remove('loading');
            });   
    }

    function filterByCat(e){
        if(e.type=='reset'){
            typeButtons.forEach(button=>{
                if(button.dataset.type=='all'){
                    button.classList.add('active');
                }
                else{
                    button.classList.remove('active');
                }
            });
            document.querySelector('#filter form').reset();
            filterByType('all');
        }
        else{
            e.preventDefault();
        }
        document.body.classList.add('loading');
        let formData=new FormData(document.querySelector('#filter form'));
        formData.append('project_type',document.querySelector('#type button.active').dataset.type);
        const url = new URL(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}?${new URLSearchParams(formData)}`);
		window.history.pushState({}, '', url);
        fetch(filterProjectsEP,{
            method:'post',
            body:formData,
        })
            .then(response=>response.json())
            .then(data => {
                projects.innerHTML = data;
                document.body.classList.remove('loading');
            })
            .catch(error=>{
                console.log(error);
                document.body.classList.remove('loading');
            }); 
    }
    
    function updateSelects(e){
        let thisSelect = e.target;
        let otherSelect=[]; 
        let formSelects = e.currentTarget.querySelectorAll('#filter select');
        let selectFlag = 0;
        formSelects.forEach(select=>{
            if(select!=thisSelect){
                otherSelect[select.name]=select;
                if(select.value){
                    selectFlag++;
                }
            }
        });
       
        if(selectFlag==2){
            let form = document.querySelector('#filter form');
            form.dispatchEvent(new Event('submit'));
            return;
        }
  
        otherSelect.forEach(select=>select.classList.add('processing'));

        let activeType = document.querySelector('#type button.active').dataset.type
        
        let params = new URLSearchParams(new FormData(e.currentTarget));
        params.append('project_type',activeType);
        fetch(`${changeSelectsEP}?project_type=${activeType}&${thisSelect.name}=${thisSelect.value}`)
            .then(response=>response.json())
            .then(data => {
                document.querySelector('#filter').innerHTML=data;
                addFilterListeners();
            })
            .catch(error=>{
                console.log(error);
                otherSelect.forEach(select=>select.classList.remove('processing'));
            });
        let form = document.querySelector('#filter form');
        form.dispatchEvent(new Event('submit')); 
    }
})();